import { render, staticRenderFns } from "./RolesToText.vue?vue&type=template&id=508c52ce&"
import script from "./RolesToText.vue?vue&type=script&lang=js&"
export * from "./RolesToText.vue?vue&type=script&lang=js&"
import style0 from "./RolesToText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports